import React, { createContext, useContext, useState } from 'react';

const ImageCompressingContext = createContext(null);

export const ImageCompressingContextProvider = ({ children }) => {
  const [imageCompressingContext, setImageCompressingContext] = useState(null);

  return (
    <ImageCompressingContext.Provider
      value={{ imageCompressingContext, setImageCompressingContext }}>
      {children}
    </ImageCompressingContext.Provider>
  );
};

export const useImageCompressingContext = () => {
  return useContext(ImageCompressingContext);
};
